import { __ } from '../../../locales'

const ItemBackgroundFilter = ({ inputs, onInputsChange }) => {
    return (
        <div className={'input-component'}>
            <label>{__('inputs.review_item_background.label')}:</label>
            <input
                type="color"
                className="form-control"
                value={inputs.itemBackground}
                onInput={(ev) => onInputsChange('itemBackground', ev.target.value)}
            />
        </div>
    );
};

export default ItemBackgroundFilter;
